import { Card, Typography } from 'antd';
import moment from 'moment/moment';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Utils from 'utils/utils';
import { CounterofferStatus } from 'utils/constants';

import { CountryFlag, Popover } from 'componets/ui';
import { CounterofferButton } from './CounterofferButton';

import { ICounterofferButton } from 'models';

import styles from './index.module.scss';

type CounterofferCardProps = {
	date: string;
	title: string;
	rows: Row[];
	buttons: ICounterofferButton[];
	id: number;
	country?: { id: number; iso: string; title: string };
};

type Row = { title: string; value: string; isStatus?: boolean };

export const CounterofferCard = ({
	date,
	title,
	rows,
	id,
	buttons,
	country,
}: CounterofferCardProps) => {
	const { t } = useTranslation();

	date = moment(new Date(date)).format('YYYY-MM-DD');

	return (
		<Card className={styles.root}>
			<div className={styles.header}>
				<div className={styles.project}>
					{country?.iso ? (
						<Popover content={country.title} trigger="hover">
							<span className={styles.flagWrapper}>
								<CountryFlag country={country.iso} />
							</span>
						</Popover>
					) : null}
					<Link className={styles.link} to={`/account/projects/${id}`}>
						{title}
					</Link>
				</div>
				<div>
					{t('offerDateText')}: {date}
				</div>
			</div>
			<div className={styles.content}>
				{rows.map((item) => (
					<CounterofferRow key={item.title} {...item} />
				))}
			</div>
			<div className={styles.footer}>
				{buttons.map((item) => (
					<CounterofferButton
						key={item.text}
						{...item}
						text={t(item.text)}
						confirmTitle={item.confirmTitle && t(item.confirmTitle)}
						confirmText={item.confirmText && t(item.confirmText)}
					/>
				))}
			</div>
		</Card>
	);
};

const CounterofferRow = ({ title, isStatus, value }: Row) => {
	const { t } = useTranslation();

	return (
		<div className={styles.row}>
			<Typography.Text type="secondary">{t(title)}</Typography.Text>
			<Typography.Text className={styles.value}>
				{isStatus ? (
					<div
						className={classNames(styles.status, {
							[styles.red]: value === CounterofferStatus.CANCELED,
							[styles.green]: value === CounterofferStatus.COMPLETED,
						})}
					>
						{t(value)}
					</div>
				) : (
					Utils.moneyFormat(+value)
				)}
			</Typography.Text>
		</div>
	);
};
